import { Component, OnInit, Input } from '@angular/core';
import { TwitterService } from 'src/app/services/social/twitter.service';

@Component({
  selector: 'app-twitter-item',
  templateUrl: './twitter-item.component.html',
  styleUrls: ['./twitter-item.component.css']
})
export class TwitterItemComponent implements OnInit {

  @Input() tweet: any = {};

  constructor(
    private twitterService: TwitterService,
  ) { }

  ngOnInit() {
    this.twitterService.replied_tweet.subscribe( tweet_id => {
      if (!tweet_id) return;
      if (tweet_id == this.tweet.tweet_id) {
        this.tweet.is_handled = true;
      }
    });
  }

  mark_tweet_as_handled() {
    this.tweet = {
      ...this.tweet,
      is_handled: true
    }
  }

  reply() {
    this.twitterService.tweet_to_reply.next(this.tweet);
  }
}
